export default __webpack_public_path__ + "static/media/cloud2.88477f08.png";